/*
 * Copyright (c) 2025 Helvia Technologies PC <contact@helvia.io>
 */

import { useEffect, useState } from 'react';

/**
 * Custom hook returns a boolean value indicating whether the screen size is extra large (1200px or wider)
 * and updates this value based on window resize events.
 *
 * @returns boolean value indicating whether the screen size is extra large (equal to or greater than 1200
 * pixels in width).
 */
export const useExtraLargeScreen = () => {
  const [isXl, setIsXl] = useState(window.innerWidth >= 1200);

  useEffect(() => {
    let timeoutId;

    const handleResize = () => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        setIsXl(window.innerWidth >= 1200);
      }, 150);
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
      clearTimeout(timeoutId);
    };
  }, []);

  return isXl;
};
